const url = '/service-address-to-options';
const Provider = 'serviceAddressToOptions';
const dbModel = 'serviceAddressToOptions';

export { url, Provider, dbModel };
